import React from 'react'
import RImageGallery from 'react-image-gallery'
import './ImageGalleryOriginal.less'
import './ImageGallery.less'

const ImageGallery = React.forwardRef((props, ref) => {
  return (
    <RImageGallery
      ref={ref}
      lazyLoad
      showNav={false}
      showThumbnails={false}
      showFullscreenButton={false}
      showPlayButton={false}
      {...props}
    />
  )
})

ImageGallery.displayName = 'ImageGallery'

export default ImageGallery
